var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import Paragraph from '../Paragraph';
import CookiesButton from './components/CookiesButton';
import CookieIcon from './components/CookieIcon';
import Container from './components/Container';
const useStyles = makeStyles(({ palette }) => ({
    text: {
        color: palette.primary.contrastText,
    },
}));
/**
 *
 * API:
 *
 * - [CookiesBanner API](https://components-extra.netlify.app/components/cookies-banner)
 */
const CookiesBanner = (_a) => {
    var { children, forwardedRef, text } = _a, rest = __rest(_a, ["children", "forwardedRef", "text"]);
    const classes = useStyles();
    return (React.createElement(Container, Object.assign({ ref: forwardedRef }, rest),
        React.createElement(CookieIcon, null),
        text && (React.createElement(Paragraph, { variant: "body2", className: classes.text }, text)),
        children));
};
CookiesBanner.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string,
};
const CookiesBannerExtra = styled(forwardRef((props, ref) => (React.createElement(CookiesBanner, Object.assign({}, props, { forwardedRef: ref }))))) ``;
/**
 * Exposed Components
 */
CookiesBannerExtra.Button = CookiesButton;
export default CookiesBannerExtra;
